/**
 * Service: programApi
 */
angular.module('acme.common.service.programApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('ProgramApiService', [ '$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function ($http, ApiVersionFactory, QueryStringBuilderFactory) {
   return {

     service: '',
     endpoint: '',

     init: function (endpoint) {
       this.endpoint = endpoint;
       this.service = endpoint + '/event/templates';
       this.instances.service = endpoint + '/event/instance';
       this.instances.times.service = endpoint + '/event/instances';
       this.times.service = endpoint + '/event/instance/times';
       this.schedules.service = endpoint + '/event/template';
       this.flexpay.service = endpoint + '/event/template';
       this.template.service = endpoint + '/event/template';
       this.prerequisites.service = endpoint + '/event/template';
       this.dependents.service = endpoint + '/event/template';
       this.recommendations.service = endpoint + '/event/template';
       this.memberships.service = endpoint + '/event/template';
       this.entitlements.service = endpoint + '/event/templates';
       this.trash.service = endpoint + '/event/instances/trash/bin';
       this.cancel.service = endpoint + '/event/cancel';
       // Plural for v2 API
       this.resources.service = endpoint + '/event/templates';
       this.resources.schedule.service = endpoint + '/event/templates';
       this.resources.instance.service = endpoint + '/event/instance';
       this.resources.requests.service = endpoint + '/event/resources/requests';
       return this;
     },

     list: function (showPrivate, props) {
       var q = '';

       if (props) {
         props.type = (showPrivate) ? 'private': '';
         var qs = new QueryStringBuilderFactory({
           props: props,
           fields: {
             optional: ['type', 'admissionType', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
           }
         });
         q = qs.query;
       }

       return $http({
         method: 'get',
         url: this.service.replace(/v1/, 'v2') + '/summaries' + q,
         timeout: 15000
       });
     },

     listOrdered: function (props) {
       var q = '';

       if (props) {
         var qs = new QueryStringBuilderFactory({
           props: props,
           fields: {
             optional: ['type', 'admissionType', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
           }
         });
         q = qs.query;
       }

       return $http({
         method: 'get',
         url: this.service.replace(/v1/, 'v2') + '/displayOrder' + q,
         timeout: 15000
       });
     },

     displayOrderCount: function (props) {
       var  path = [ this.service, 'displayOrder', 'count'],
            av = new ApiVersionFactory();

       if (props && props.eventTemplateId) {
         path.splice(2, 0, props.eventTemplateId);
       }

       return $http({
         method: 'get',
         url: av.init({
           url: path.join('/'),
           version: 'v2'
         }),
         timeout: 15000
       });
     },

     reorder: function (props) {
       return $http({
         method: 'put',
         url: this.service.replace(/v1/, 'v2') + '/displayOrder',
         data: props
       });
     },

     names: function (showPrivate, props) {
       var q = '',
           av = new ApiVersionFactory();

       if (props) {
         props.type = (showPrivate) ? 'private': '';
         var qs = new QueryStringBuilderFactory({
           props: props,
           fields: {
             optional: ['type', 'admissionType', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
           }
         });
         q = qs.query;
       }

       return $http({
         method: 'get',
         url: av.init({
           url: this.service + '/names' + q,
           version: 'v2'
         }),
         timeout: 15000
       });
     },

     create: function (props, publish) {
       //endTime is always null since multiple schedules code was introduced.
       var q = '',
           data = {
             name: props.name,
             type: props.type,
             description: props.description,
             shortDescription: props.shortDescription,
             emailConfirmationMessage: props.emailConfirmationMessage,
             emailCancellationMessage: props.emailCancellationMessage,
             admissionType: props.admissionType || 'standard',
             membership: props.membership,
             GLCode: props.GLCode,
             customFields: props.customFields,
             thirdPartyEvent: props.thirdPartyEvent,
             thirdPartyPercentage: props.thirdPartyPercentage,
             repeatCycle: props.repeatCycle,
             summary: props.summary,
             emailNotify: props.emailNotify,
             onlinePaymentsForOrgOrdersEmailNotify: props.onlinePaymentsForOrgOrdersEmailNotify,
             rebookingFee: props.rebookingFee,
             addOns: props.addOns,
             images: props.images,
             startTime: props.startTime,
             endTime: null,
             reviewState: props.reviewState,
             flexPays: props.flexPays,
             schedules: props.schedules,
             resources: props.resources,
             ticketDetails: props.ticketDetails,
             colorCategory: props.colorCategory,
             memberOnlyEvent: props.memberOnlyEvent,
             allMembersCanPurchase: props.allMembersCanPurchase,
             entitlementConfiguration: props.entitlementConfiguration
           };

       data = this.stripNewSchedules(data);

       if ( props.reviewState && (props.reviewState !== 'published') ) {
         // only send pricelists if they are present.
         if ( (props.priceLists instanceof Array) && (props.priceLists.length > 0) && props.priceLists[0] && props.priceLists[0].hasOwnProperty('id') ) {
           data.priceLists = props.priceLists;
         }
       }else {
         data.priceLists = props.priceLists;
       }

       if (publish) {
         q += '?publish=true';
       }

       return $http({
         method: 'post',
         url: this.service.replace(/v1/, 'v2') + q,
         data: data
       });
     },

     update: function (props, publish) {
       //endTime is always null since multiple schedules code was introduced.
       var q = '',
           data = {
             id: props.id,
             name: props.name,
             type: props.type,
             description: props.description,
             shortDescription: props.shortDescription,
             emailConfirmationMessage: props.emailConfirmationMessage,
             emailCancellationMessage: props.emailCancellationMessage,
             admissionType: props.admissionType || 'standard',
             membership: props.membership,
             GLCode: props.GLCode,
             customFields: props.customFields,
             thirdPartyEvent: props.thirdPartyEvent,
             thirdPartyPercentage: props.thirdPartyPercentage,
             repeatCycle: props.repeatCycle,
             summary: props.summary,
             emailNotify: props.emailNotify,
             onlinePaymentsForOrgOrdersEmailNotify: props.onlinePaymentsForOrgOrdersEmailNotify,
             rebookingFee: props.rebookingFee,
             addOns: props.addOns,
             images: props.images,
             startTime: props.startTime,
             endTime: null,
             reviewState: props.reviewState,
             flexPays: props.flexPays,
             schedules: props.schedules,
             resources: props.resources,
             prerequisites: props.prerequisites,
             recommendations: props.recommendations,
             ticketDetails: props.ticketDetails,
             colorCategory: props.colorCategory,
             memberOnlyEvent: props.memberOnlyEvent,
             allMembersCanPurchase: props.allMembersCanPurchase,
             entitlementConfiguration: props.entitlementConfiguration
           };

       data = this.stripNewSchedules(data);

       if ( props.reviewState && (props.reviewState !== 'published') ) {
         // only send pricelists if they are present.
         if ( (props.priceLists instanceof Array) && (props.priceLists.length > 0) && props.priceLists[0] && props.priceLists[0].hasOwnProperty('id') ) {
           data.priceLists = props.priceLists;
         }
       }else {
         data.priceLists = props.priceLists;
       }

       if (publish) {
         q += '?publish=true';
       }

       return $http({
         method: 'put',
         url: this.service.replace(/v1/, 'v2') + '/' + props.id + q,
         data: data
       });
     },

     get: function (id, noCache, httpCache) {
       var q = '';

       if (noCache) {
         q = '?cache=false';
       }

       return $http({
         method: 'get',
         url: this.service.replace(/v1/, 'v2') + '/' + id + q,
         cache: httpCache
       });
     },

     remove : function(props) {
       var av = new ApiVersionFactory();
       return $http({
         method: 'delete',
         url: av.init({
           url: this.service + '/' + props.id,
           version: 'v2'
         })
       });
     },

     stripNewSchedules: function(data) {
       var i, ii;

       if (data.schedules && data.schedules.length > 0) {
         for (i=0,ii=data.schedules.length;i<ii;i++) {
           if (data.schedules[i].hasOwnProperty('NEW')) {
             data.schedules[i].NEW = null;
             delete data.schedules[i].NEW;
           }
         }
       }

       return data;
     },

     template: {

       service: '',

       /**
        * @param props.eventTemplateId
        */
       published: function (props) {
         return $http({
           method: 'get',
           url: this.service + '/' + props.eventTemplateId + '/published'
         });
       }

     },

     schedules: {

       service: '',

       list: function (id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id + '/schedules/'
         });
       },

       create: function(props) {
         return $http({
           method: 'post',
           url: this.service + '/' + props.eventTemplateId + '/schedules/',
           data: {
             name: props.name,
             description: props.description,
             effectiveStartTime: props.effectiveStartTime,
             effectiveEndTime: props.effectiveEndTime,
             honorHolidays: props.honorHolidays,
             honorOpenHours: props.honorOpenHours,
             repeatCycle: props.repeatCycle,
             capacity: props.capacity,
             duration: props.duration,
             weekdays: props.weekdays,
             daysOfMonth: props.daysOfMonth,
             days: props.days,
             monthly: props.monthly,
             hours: props.hours,
             ranges: props.ranges,
             blockFlexPays: props.blockFlexPays,
             salesChannels: props.salesChannels,
             priceLists: props.priceLists,
             resourceRequests: props.resourceRequests,
             ticketConfig: props.ticketConfig,
             orderForms: props.orderForms,
             type: props.type
           }
         });
       },

       update: function(props) {
         return $http({
           method: 'put',
           url: this.service + '/' + props.eventTemplateId + '/schedules/' + props.id,
           data: {
             id: props.id,
             name: props.name,
             description: props.description,
             effectiveStartTime: props.effectiveStartTime,
             effectiveEndTime: props.effectiveEndTime,
             honorHolidays: props.honorHolidays,
             honorOpenHours: props.honorOpenHours,
             repeatCycle: props.repeatCycle,
             capacity: props.capacity,
             duration: props.duration,
             weekdays: props.weekdays,
             daysOfMonth: props.daysOfMonth,
             days: props.days,
             monthly: props.monthly,
             hours: props.hours,
             ranges: props.ranges,
             blockFlexPays: props.blockFlexPays,
             salesChannels: props.salesChannels,
             priceLists: props.priceLists,
             resourceRequests: props.resourceRequests,
             ticketConfig: props.ticketConfig,
             orderForms: props.orderForms,
             type: props.type
           }
         });
       },

       remove: function(props) {
         return $http({
           method: 'delete',
           url: this.service + '/' + props.eventTemplateId + '/schedules/' + props.id
         });
       }
    },

     flexpay: {

       service: '',

       list: function (id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id + '/flexpay/'
         });
       },

       create: function(props) {
         return $http({
           method: 'post',
           url: this.service + '/' + props.eventTemplateId + '/flexpay/',
           data: {
             name: props.name,
             type: props.type,
             effectiveStartTime: props.effectiveStartTime,
             effectiveEndTime: props.effectiveEndTime,
             repeatCycle: props.repeatCycle,
             weekdays: props.weekdays,
             daysOfMonth: props.daysOfMonth,
             days: props.days,
             monthly: props.monthly,
             hours: props.hours,
             range: props.range,
             discountId: props.discountId
           }
         });
       },

       update: function(props) {
         return $http({
           method: 'put',
           url: this.service + '/' + props.eventTemplateId + '/flexpay/' + props.id,
           data: {
             id: props.id,
             name: props.name,
             type: props.type,
             effectiveStartTime: props.effectiveStartTime,
             effectiveEndTime: props.effectiveEndTime,
             repeatCycle: props.repeatCycle,
             weekdays: props.weekdays,
             daysOfMonth: props.daysOfMonth,
             days: props.days,
             monthly: props.monthly,
             hours: props.hours,
             range: props.range,
             discountId: props.discountId
           }
         });
       },

       remove: function(props) {
         return $http({
           method: 'delete',
           url: this.service + '/' + props.eventTemplateId + '/flexpay/' + props.id
         });
       }
     },

     prerequisites: {

       service: '',

       detail: function(id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id + '/prerequisites'
         });
       },

       create: function(id, props) {
         return $http({
           method: 'post',
           url: this.service + '/' + id  + '/prerequisites',
           data: {
             operation: props.operation,
             prerequisites: props.prerequisites
           }
         });
       },

       update: function(id, props) {
         return $http({
           method: 'put',
           url: this.service + '/' + id  + '/prerequisites',
           data: {
             operation: props.operation,
             prerequisites: props.prerequisites
           }
         });
       },

       remove: function(id) {
         return $http({
           method: 'delete',
           url: this.service + '/' + id  + '/prerequisites'
         });
       }

     },

     dependents: {

      service: '',

      list: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id + '/dependents'
        });
      },

      create: function(id, props) {
        return $http({
          method: 'post',
          url: this.service + '/' + id  + '/dependents',
          data: {
            dependents: props.dependents
          }
        });
      },

      update: function(id, props) {
        return $http({
          method: 'put',
          url: this.service + '/' + id  + '/dependents',
          data: {
            dependents: props.dependents
          }
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id  + '/dependents'
        });
      }

    },

     memberships: {
      service: '',

       list: function(id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id  + '/memberships'
         });
       }
     },

     entitlements: {
       service: '',

        list: function(id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({url: this.service + '/' + id  + '/entitlements', version: 'v2'})
          });
        }
      },

     recommendations: {

       service: '',

       detail: function(id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id + '/recommendations'
         });
       },

       create: function(id, props) {
         return $http({
           method: 'post',
           url: this.service + '/' + id  + '/recommendations',
           data: {
             recommendations: props.recommendations,
             tags: props.tags
           }
         });
       },

       update: function(id, props) {
         return $http({
           method: 'put',
           url: this.service + '/' + id  + '/recommendations',
           data: {
             recommendations: props.recommendations,
             tags: props.tags
           }
         });
       },

       remove: function(id) {
         return $http({
           method: 'delete',
           url: this.service + '/' + id  + '/recommendations'
         });
       }

     },

     instances: {
       service: '',

       discount: function(props) {
         var q = '';

         if (props) {
           var qs = new QueryStringBuilderFactory({
             props: props,
             fields: {
               optional: ['accountId', 'membershipId']
             }
           });
           q = qs.query;
         }

         return $http({
           method: 'get',
           url: this.service + '/' + props.id + q
         });

       },

       detail: function(id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id
         });
       },

       update: function(props) {
         return $http({
           method: 'put',
           url: this.service,
           data: {
             id: props.id,
             templateId: props.templateId,
             scheduleId: props.scheduleId,
             originalFields: props.originalFields,
             name: props.name,
             description: props.description,
             colorCategory: props.colorCategory,
             shortDescription: props.shortDescription,
             emailConfirmationMessage: props.emailConfirmationMessage,
             emailCancellationMessage: props.emailCancellationMessage,
             capacity: props.capacity,
             GLCode: props.GLCode,
             startTime: props.startTime,
             endTime: props.endTime,
             flexPays: props.flexPays,
             resources: props.resources,
             resourceDetails: props.resourceDetails,
             resourceRequests: props.resourceRequests,
             priceList: props.priceList,
             rebookingFee: props.rebookingFee,
             ticketConfig: props.ticketConfig,
             ticketDetails: props.ticketDetails,
             addOns: props.addOns,
             customFields: props.customFields,
             offSchedule: props.offSchedule,
             orderForms: props.orderForms,
             sendEmail: props.sendEmail,
             organization: props.organization,
             salesChannels: props.salesChannels,
             state: props.state
           }
         });
       },

       remove: function(props) {
         var q = '';
         if (props) {
           var qs = new QueryStringBuilderFactory({
             props: props,
             fields: {
               optional: ['sendEmail']
             }
           });
           q = qs.query;
         }

         return $http({
           method: 'delete',
           url: this.service + '/' + props.id + q
         });
       },

       resources: function(id) {
         return $http({
           method: 'get',
           url: this.service + '/' + id + '/resources'
         });
       },

       rebookFees: function(ids) {
         return $http({
           method: 'get',
           url: this.service + '/rebook/fees?eventIds=' + ids
         });
       },

       times: {

         list: function(props) {
           var q = '',
             av = new ApiVersionFactory();

           if (props) {
             var qs = new QueryStringBuilderFactory({
               props: props,
               fields: {
                 optional: ['templateId', 'startTime', 'endTime', 'pageSize', 'page', 'sortField', 'sortDirection', 'saleChannel', 'type', 'search', 'filter']
               }
             });
             q = qs.query;
           }
           return $http({
             method: 'get',
             url: av.init({url: this.service + q, version: 'v2'})
           });
         }
       },

       updatePrivate: function (props) {
         var av = new ApiVersionFactory();
         return $http({
           method: 'post',
           url: this.service + '/update',
           data: {
             id: props.id,
             templateId: props.templateId,
             scheduleId: props.scheduleId,
             originalFields: props.originalFields,
             name: props.name,
             description: props.description,
             colorCategory: props.colorCategory,
             shortDescription: props.shortDescription,
             emailConfirmationMessage: props.emailConfirmationMessage,
             emailCancellationMessage: props.emailCancellationMessage,
             capacity: props.capacity,
             GLCode: props.GLCode,
             startTime: props.startTime,
             endTime: props.endTime,
             flexPays: props.flexPays,
             resources: props.resources,
             resourceDetails: props.resourceDetails,
             resourceRequests: props.resourceRequests,
             priceList: props.priceList,
             rebookingFee: props.rebookingFee,
             ticketConfig: props.ticketConfig,
             addOns: props.addOns,
             customFields: props.customFields,
             offSchedule: props.offSchedule,
             orderForms: props.orderForms,
             sendEmail: props.sendEmail,
             organization: props.organization,
             salesChannels: props.salesChannels
           }
         });
       }
     },

     resources: {

       service: '',

       schedule: {

         service: '',

         list: function (props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'get',
             url: av.init({
               url: this.service + '/' + props.templateId + '/schedules/' + props.scheduleId + '/resources',
               version: 'v2'
             })
           });

         },

         create: function (props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'post',
             url: av.init({
               url: this.service + '/' + props.templateId + '/schedules/' + props.scheduleId + '/resources',
               version: 'v2'
             }),
             data: {
               resourceTimeFrame: props.resourceTimeFrame,
               eventResource: props.eventResource,
               notes: props.notes,
               sendEmail: props.sendEmail
             }
           });

         },

         update: function (props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'put',
             url: av.init({
               url: this.service + '/' + props.templateId + '/schedules/' + props.scheduleId + '/resources',
               version: 'v2'
             }),
             data: {
               id: props.id,
               resourceTimeFrame: props.resourceTimeFrame,
               eventResource: props.eventResource,
               notes: props.notes,
               sendEmail: props.sendEmail
             }
           });

         },

         remove: function (props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'delete',
             url: av.init({
               url: this.service + '/' + props.templateId + '/schedules/' + props.scheduleId + '/resources',
               version: 'v2'
             }),
             data: {
               id: props.id,
               resourceTimeFrame: props.resourceTimeFrame,
               eventResource: props.eventResource,
               notes: props.notes,
               sendEmail: props.sendEmail
             }
           });

         },

         summary: function (props) {

           var av = new ApiVersionFactory(), q;

           if(props) {
             var qs = new QueryStringBuilderFactory({
               props: props,
               fields: {
                 optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'formId']
               }
             });
             q = qs.query;
           }

           return $http({
             method: 'get',
             url: av.init({ url: this.service + '/schedules/summary' + q, version: 'v2' })
           });
         }
       },

       instance: {

         service: '',

         list: function(props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'get',
             url: av.init({
               url: this.service + '/' + props.id + '/resourcerequests',
               version: 'v2'
             })
           });

         },

         create: function(props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'post',
             url: av.init({
               url: this.service + '/' + props.id + '/resourcerequests',
               version: 'v2'
             }),
             data: {
               resourceTimeFrame: props.resourceTimeFrame,
               eventResource: props.eventResource,
               notes: props.notes,
               sendEmail: props.sendEmail
             }
           });

         },

         update: function(props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'put',
             url: av.init({
               url: this.service + '/' + props.eventId + '/resourcerequests',
               version: 'v2'
             }),
             data: {
               id: props.id,
               resourceTimeFrame: props.resourceTimeFrame,
               eventResource: props.eventResource,
               notes: props.notes,
               sendEmail: props.sendEmail
             }
           });

         },

         remove: function (props) {

           var q = '',
               av = new ApiVersionFactory();

           if (props) {
             var qs = new QueryStringBuilderFactory({
               props: props,
               fields: {
                 optional: ['sendEmail']
               }
             });
             q = qs.query;
           }

           return $http({
             method: 'delete',
             url: av.init({
               url: this.service + '/' + props.id + '/resourcerequests/' + props.requestId + q,
               version: 'v2'
             })
           });

         },

         detail: function (props) {

           var av = new ApiVersionFactory();

           return $http({
             method: 'get',
             url: av.init({
               url: this.service + '/' + props.id + '/resourcerequests/' + props.requestId,
               version: 'v2'
             })
           });

         }

       },

       requests: {

         service: '',

         list: function(props) {

           var av = new ApiVersionFactory(),
             qs = new QueryStringBuilderFactory({
               props: props,
               fields: {
                 optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'eventId', 'ownerId', 'resourceStartTime', 'resourceEndTime', 'eventTemplateId']
               }
             }),
             q = qs.query;

           return $http({
             method: 'get',
             url: av.init({ url: this.service + q, version: 'v2' })
           });

         }
       }

     },

     times: {
       service: '',

       detail: function(id) {
         var av = new ApiVersionFactory();
         return $http({
           method: 'get',
           url: av.init({ url: this.service + '/' + id, version: 'v2' })
         });
       },

       update: function(props) {
         var av = new ApiVersionFactory();
         return $http({
           method: 'put',
           url: av.init({ url: this.service, version: 'v2' }),
           data: {
             id: props.id,
             startTime: props.startTime,
             endTime: props.endTime,
             moveResources: props.moveResources,
             duration: props.duration,
             notifyBuyers: props.notifyBuyers
           }
         });
       }
     },

     trash: {
       service: '',

       list: function(props, options){
         var q = '',
             properties = angular.extend({}, props, options);

         if (properties) {
           var qs = new QueryStringBuilderFactory({
             props: properties,
             fields: {
               requires: ['startTime'],
               optional: ['templateId', 'endTime', 'pageSize', 'page', 'sortField', 'sortDirection', 'search', 'requestFilter']
             }
           });
           q = qs.query;
         }
         return $http({
           method: 'get',
           url: this.service.replace(/v1/, 'v2') + q
         });
       },

       recover: function(id){
         return $http({
           method: 'put',
           url: this.service + '/recover' + '/' + id
         });
       },

       detail: function(id){
         return $http({
           method: 'get',
           url: this.service + '/' + id
         });
       },

       recoverBulk: function(ids){
         return http({
           method: 'put',
           url: this.service,
           data: ids
         });
       }
     },

     cancel: {

       service: '',

       event: function(props) {
         return $http({
          method: 'post',
          url: this.service.replace(/v1/, 'v2'),
          data: {
            eventId: props.id,
            sendEmail: props.sendEmail,
            sendEmailToResources: props.sendEmailToResources,
            emailMessage: props.emailMessage
          }
         });
       }

     }

   };
 }]
);
